import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import { colours } from '../../StyleConstants'

const LassoSwitch = styled(Switch)(() => ({
    padding: 10,
    '& .MuiSwitch-switchBase': {
        padding: 11,
        '&.Mui-checked': {
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: colours.orange.orange
            }
        },
    },
    '& .MuiSwitch-thumb': {
        width: 16,
        height: 16,
    },
    '& .MuiSwitch-track': {
        borderRadius: 20,
        opacity: 1,
        backgroundColor: '#5B5D5D',
    },
}));

export default LassoSwitch;
